import { hasValue, isValidDate } from 'common/validations/field';
import i18n from 'i18n';

// Espejo del regex del backend (CreateNewsInput.title): comienza con letra o número y
// solo prohíbe < y >. Así el error se ve EN el campo antes de enviar, en vez del
// genérico "verifica los datos ingresados" del servidor.
const TITLE_PATTERN = /^[\p{L}\p{N}][^<>]*$/u;

const defaultNewsFormValidations = (values) => {
  const errors = {};

  if (!hasValue(values.body)) {
    errors.body = i18n.t('emptyField', { ns: 'validations' });
  }

  if (!isValidDate(values.created_at)) {
    errors.created_at = i18n.t('date', { ns: 'validations' });
  }

  if (!hasValue(values.title)) {
    errors.title = i18n.t('emptyField', { ns: 'validations' });
  } else if (!TITLE_PATTERN.test(values.title.trim())) {
    errors.title = i18n.t('newsTitleCharset', {
      ns: 'validations',
      defaultValue: 'Debe comenzar con letra o número. Los caracteres < y > no están permitidos'
    });
  }

  return errors;
};

export default defaultNewsFormValidations;
